import { FileTriggerProps, FileTrigger as ReactAriaFileTrigger } from "react-aria-components";

export type NcFileTriggerProps = FileTriggerProps;

export const NcFileTrigger = ({ ...props }: NcFileTriggerProps) => (
  <ReactAriaFileTrigger data-nc="NcFileTrigger" {...props} />
);
